import { useI18nContext } from '@ecg-internal/js-react-i18n';
import { ButtonIcon, SecondaryButton } from '@hz-design-system/web-ui';
import React from 'react';
import Classes from './SaveSellerControl.module.scss';

type SaveSellerControlProps = {
  isSellerSaved: boolean;
  loading?: boolean;
  onClick: (...args: any[]) => void;
  sellerId: number;
};
const SaveSellerControl = ({ onClick, sellerId, isSellerSaved, loading = false }: SaveSellerControlProps) => {
  const { t } = useI18nContext();

  return (
    <div className={Classes.root}>
      <div id="save-seller">
        <form id="save-seller-form" action="">
          <input name="sellerId" type="hidden" value={sellerId} />
          <SecondaryButton onClick={onClick} title={t('sellerHeader.buttonTitleFollowSeller')} disabled={loading}>
            <ButtonIcon name={isSellerSaved ? 'following' : 'follow'} isStartIcon={false} />
          </SecondaryButton>
        </form>
      </div>
    </div>
  );
};

export default SaveSellerControl;
